export const OnboardingScreen1Helper = {
    header: 'Welcome to your LifeTrek!',
    subHeader: 'LifeTrek connects you with learning opportunities that are uniquely created for you, and gives you ownership and control of your  achievements - no matter where your journey takes you.',
    buttonLabel: 'Get Started'
}